"use client";

import { Input } from "@/components/ui/input";
import { handleEmailEntry } from "./actions";
import { Form, FormField } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useTransition } from "react";
import { SubmitButton } from "@/components/FormFields";
import Image from "next/image";
import { GoogleLoginButton } from "@/components/GoogleLoginButton";
import { WebloginLoginButton } from "@/components/WebloginLoginButton";

export default function LoginPage() {
  const form = useForm({
    resolver: zodResolver(
      z.object({
        email: z.string().email(),
      }),
    ),
    defaultValues: {
      email: "",
    },
  });
  const [isPending, startTransition] = useTransition();
  return (
    <div className="grid grid-rows-1 justify-items-center min-h-screen p-8 pb-20 sm:p-20 font-[family-name:var(--font-geist-sans)]">
      <main className="flex flex-col gap-8 items-center sm:items-start max-w-[36rem]">
        <Image
          src={"/Signups.png"}
          alt="Roses 2026 Media Signups"
          height={250}
          width={250}
          className="self-center"
        />
        <h1 className="text-2xl font-bold">Welcome Back</h1>
        <p>If you have a york.ac.uk email, log in with Google:</p>
        <GoogleLoginButton size={"lg"} />
        <p>If you are a Lancaster University student please login here:</p>
        <WebloginLoginButton size={"lg"} />
        <p>Enter your email below to update your details.</p>
        <Form {...form}>
          <form
            action={handleEmailEntry}
            onSubmit={form.handleSubmit((data) =>
              startTransition(() => handleEmailEntry(data)),
            )}
            className="w-full"
          >
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Email address"
                  type="email"
                  className="w-full"
                />
              )}
            />
            <SubmitButton
              submitting={isPending}
              className="mt-2 ml-auto !block"
            >
              Continue
            </SubmitButton>
          </form>
        </Form>
      </main>
    </div>
  );
}
